export default {
    leftname:"阳光智慧娱乐商户平台",
    loginname:"请输入账户",
    loginyan:"请输入验证码",
    loginpass:"请输入账户密码",
    loginqu:"我是渠道商",
    loginshang:"我是商户",
    denglu:"登录",
    qudaoshang:"渠道商：",
    pingtai:"平台",
    danjisaas:"单机运维系统",
    danjiding:"单机订单系统",
    yangguang:"慧算通经营管理系统",
    mendian:"门店运维系统",
    mendianding:"门店订单系统",
    quanxian:"员工管理",
    huanying:"欢迎登录",
    tuichu:"退出登录" ,
    shanghu:"商户：",
    "下载": "下载",
    "收银客户端下载": "收银客户端下载",
    "谷歌浏览器下载": "谷歌浏览器下载",
    "阳光视翰官网": "阳光视翰官网",
    "24小时客服热线": "24小时客服热线",
    "点击跳转": "点击跳转",
    "点击复制": "点击复制",
    "记住密码": "记住密码"
};
